/* istanbul ignore file */
import WaitAnalysis from './WaitAnalysis';

export default WaitAnalysis;
